import { colors } from '@lmc/common/constants'
import { trackEvent } from '../../../../common/services/intercom'
import { hexToRgbA } from '../../../../common/utils'
import {
  FamilyFeaturesSettings,
  FamilyLogDetailsSettings
} from '../../../../screens/AccountsSettings/FamilySettings/components'
import { OldButton } from '../../../generic'
import {
  BodyText,
  Container,
  Footer,
  FooterSubContainer,
  GreyBodyText,
  Header
} from './FamilyPortalStyles'

interface FamilyPortalFeaturesProps {
  fields?: any
  home: any
  formId: string
  goToNextStep?: () => void
  preferredCarePlansNominative: string
  mixpanel: any // Define the type for mixpanel
}

export default function FamilyPortalFeatures({
  fields = {},
  formId,
  goToNextStep,
  home,
  mixpanel,
  preferredCarePlansNominative
}: FamilyPortalFeaturesProps) {
  const onNext = () => {
    trackEvent('CO_family_set_features')
    mixpanel.track('CO_family_set_features')
    goToNextStep?.()
  }

  return (
    <Container>
      <Header>Family App Setup</Header>
      <BodyText>
        Customise what families will be able to view in their Apps. These
        changes will be applied to all family members you have using the Family
        App.
      </BodyText>
      <FamilyFeaturesSettings
        homeSettings={fields}
        formId={formId}
        preferredCarePlansNominative={preferredCarePlansNominative}
        features={home}
      />
      <FamilyLogDetailsSettings
        homeSettings={fields}
        formId={formId}
        isWhiteBackground
        featureOptionsStyle={{ paddingBottom: 60 }}
      />
      <Footer className="lmc-fixed-footer">
        <FooterSubContainer>
          <GreyBodyText>
            Note: You can always change your settings at a later date
          </GreyBodyText>
          <OldButton
            onClick={() => onNext()}
            type="add"
            text="Next Step"
            style={{
              height: 40,
              boxShadow: `0 0 8px ${hexToRgbA(colors.black, 0.2)}`
            }}
          />
        </FooterSubContainer>
      </Footer>
    </Container>
  )
}
